import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#39b0b8",
        secondary: "#0d4e6c",
        accent: "002855",
      },
    },
  },
});
